import { render, staticRenderFns } from "./PMain.vue?vue&type=template&id=2e6c421c"
import script from "./PMain.vue?vue&type=script&lang=js"
export * from "./PMain.vue?vue&type=script&lang=js"
import style0 from "./PMain.vue?vue&type=style&index=0&id=2e6c421c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports